module.exports = __webpack_public_path__ + "img/group2.72056da5.jpeg";